<template>
  <div>
    <mu-paper style="position: relative; z-index: 99; margin-bottom: 8px">
      <mu-list style="padding: 0">
        <mu-list-item disableRipple :describeText="food.brand_name">
          <div slot="title">
            <span v-text="isLoading ? $t('message.loadingText') : food.food_name"></span>
          </div>
          <mu-icon @click.native="goBack()" slot="left" value="chevron_left"></mu-icon>
        </mu-list-item>
        <mu-divider></mu-divider>
      </mu-list>
    </mu-paper>
    <mu-paper>
      <div>
        <mu-row gutter v-if="!isLoading">
          <mu-col width="100" :desktop="leftPaneWidth.desktop" :tablet="leftPaneWidth.tablet" class="bottom">
            <mu-content-block style="padding: 16px 24px;">
              <mu-row gutter style="margin-bottom: 8px">
                <mu-col
                  width="50"
                  :desktop="servingPickerWidth.servingInput.desktop"
                  :tablet="servingPickerWidth.servingInput.tablet"
                >
                  <mu-text-field
                    v-validate="'required|min_value:0|max_value:99'"
                    v-model.number="model.servings"
                    data-vv-name="serving_size"
                    :data-vv-as="$t('message.labelServingSize')"
                    :errorText="errors.first('serving_size')"
                    :min="1"
                    :max="99"
                    type="number"
                    :hintText="$t('message.labelMultiplier')"
                    :label="$t('message.labelServingSize')"
                    fullWidth
                  ></mu-text-field>
                  <span>
                </span>
                </mu-col>
                <mu-col
                  width="50"
                  :desktop="servingPickerWidth.servingSelector.desktop"
                  :tablet="servingPickerWidth.servingSelector.tablet"
                >
                  <mu-select-field
                    :scroller="scroller"
                    :maxHeight="248"
                    label=" "
                    v-model.number="model.serving_id"
                    fullWidth
                    autoWidth>
                    <mu-menu-item
                      v-for="serving, index in food.servings"
                      :key="'serving-' + index"
                      :value="serving.serving_id"
                      :title="serving.serving_description"
                    ></mu-menu-item>
                  </mu-select-field>

                </mu-col>
              </mu-row>

              <mu-row style="margin-bottom:16px">
                <mu-col style="font-weight: 500; margin-bottom: 8px;" v-text="$t('message.foodDiaryQuickPortionLabel')"
                        width="100" desktop="100" tablet="100"></mu-col>
                <mu-col width="100" desktop="100" tablet="100">
                  <mu-chip @click.native="setServingSize('0.25')">1/4</mu-chip>
                  <mu-chip @click.native="setServingSize('0.5')">1/2</mu-chip>
                  <mu-chip @click.native="setServingSize('0.75')">3/4</mu-chip>
                  <mu-chip @click.native="setServingSize('1')">1</mu-chip>
                </mu-col>
              </mu-row>
              <mu-row gutter>
                <mu-col :desktop="servingPickerWidth.servingInput.desktop"
                        :tablet="servingPickerWidth.servingInput.tablet">
                  <mu-time-picker
                    label="TIME"
                    mode="portrait"
                    fullWidth
                    v-model="timeModel.time"
                    :okLabel="$t('message.okText')"
                    :cancelLabel="$t('message.cancelText')"></mu-time-picker>
                </mu-col>
                <mu-col :desktop="servingPickerWidth.servingSelector.desktop"
                        :tablet="servingPickerWidth.servingSelector.tablet">
                  <mu-date-picker
                    label="DATE"
                    :okLabel="$t('message.okText')"
                    :cancelLabel="$t('message.cancelText')"
                    :dateTimeFormat="dateFormat"
                    format="DD-MM-YYYY"
                    v-model="timeModel.date"
                    fullWidth></mu-date-picker>
                </mu-col>
              </mu-row>


              <mu-raised-button
                label="Full nutrition" fullWidth
                                @click.native="toggleNutritionPane()"></mu-raised-button>
            </mu-content-block>
          </mu-col>
          <mu-col width="100" desktop="50" tablet="50" class="rightPane" v-if="isNutritionPaneVisible">
            <mu-card-header
              class="removePadding"
              :subTitle=" model.servings + ' x ' + activeServingObject.serving_description"
            ></mu-card-header>
            <mu-divider></mu-divider>
            <mu-list class="oddEven">
              <mu-list-item
                disableRipple
                v-for="(value, key) in activeServingObject.nutrients"
                :key="'nutrient-'+ key"
                :title="$t(localizeNutrient(key))"
                :afterText="'' + rounded(value * model.servings) + getUnit(key)"
              >
              </mu-list-item>
            </mu-list>
          </mu-col>
        </mu-row>
      </div>

      <mu-card-actions class="card-actions" align="right" v-if="!isLoading">
        <mu-flat-button :label="$t('message.cancelText')" @click.native="closeDialog('addFoodDialog')"></mu-flat-button>
        <mu-raised-button
          :label="isSaving ? $t('message.savingText') : $t('message.saveText')"
          :disabled="isSaving"
          @click.native="saveFood()"
          secondary
        ></mu-raised-button>
      </mu-card-actions>
    </mu-paper>
  </div>
</template>
<script>



  import FoodApi from '../../../api/Food'
  import config from '../../../config'
  import NutrientLocalizerMixin from '../../../mixins/Localization/FoodNutrients/NutrientLocalizer'

  let numeral = require('numeral');

  import dateFormat from "../../../helpers/DatePickerManager"

  const leftPaneWidth = {
    desktop: "100",
    tablet: "100"
  };

  const servingPickerWidth = {
    servingInput: {
      desktop: "20",
      tablet: "20"
    },
    servingSelector: {
      desktop: "80",
      tablet: "80"
    }
  };

  export default {
    mixins:[NutrientLocalizerMixin],
    props: {
      title: {
        type: String,
        default: ""
      }
    },
    watch: {
      'model.serving_id': function () {
        let self = this, serving_id = self.model.serving_id;
        self.activeServingObject = self.food.servings.filter(function (item) {
          return item.serving_id === self.model.serving_id;
        })[0];
      },
      'timeModel.time': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
      'timeModel.date': function () {
        let self = this;
        let dateTime = moment(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY hh:mm a');
        self.model.date = moment(dateTime).format();
      },
    },
    data() {
      return {
        maxDate: moment().format('DD-MM-YYYY'),
        modelDate: "",
        mealTypeId: 1,
        isSaving: false,
        isLoading: true,
        isNutritionPaneVisible: false,
        dateFormat: dateFormat,
        scroller: document.getElementsByClassName('main-content')[0],
        activeServingObject: {},
        food: {},
        leftPaneWidth: leftPaneWidth,
        servingPickerWidth: servingPickerWidth,
        model: {
          date: "",
          servings: 1,
          serving_id: 0
        },
        timeModel: {
          date: "",
          time: ""
        }
      }
    },
    mounted() {
      let self = this;
      self.modelDate = self.$route.query.date;
      self.mealTypeId = parseInt(self.$route.query.mealTypeId);
      let date = moment(self.modelDate), time = date.format('hh:mm a');
      if (self.isDst(date)) {
        date.add(1, 'hour');
      }
      self.timeModel.time = time;
      self.timeModel.date = date.format('DD-MM-YYYY');
      self.leftPaneWidth.desktop = "100";
      self.leftPaneWidth.tablet = "100";
      FoodApi.getById(self.$route.query.foodId)
        .then(function (response) {
          self.food = response.data.food;
          self.model.serving_id = self.food.servings[0].serving_id;
          self.isLoading = false;
          self.$nextTick(function () {
            $(self.$refs['dateInput']).val(moment(self.modelDate).format('YYYY-MM-DD'));
            $(self.$refs['timeInput']).val(moment(self.modelDate).format('hh:mm'))
          });
        })
    },
    methods: {
      isDst(date) {
        return moment(date).isDST();
      },
      setServingSize(size) {
        let self = this;
        self.model.servings = size;
        self.$forceUpdate();
      },
      saveFood() {
        let self = this;


        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {
              self.isSaving = true;
              let inputDate = moment.utc(self.timeModel.date + ' ' + self.timeModel.time, 'DD-MM-YYYY HH:mm a');
              if (self.isDst(inputDate)) {
                inputDate.add(1, 'hour');
              }
              let model = {
                date: self.model.date,
                meal_type_id: self.mealTypeId,
                foods: [
                  {
                    food_id: self.food.food_id,
                    food_name: self.food.food_name,
                    servings: self.model.servings,
                    serving_id: self.model.serving_id,
                    nutrients: self.activeServingObject.nutrients
                  }
                ]
              };
              FoodApi.addFoods(model)
                .then(function (response) {
                  self.isSaving = false;
                  self.$router.push({
                    name: 'FoodDiary',
                    query: {
                      date: inputDate.format('YYYY-MM-DD')
                    }
                  })
                })
                .catch(function (error) {
                  self.isSaving = false;
                  self.$router.push({
                    name: 'FoodDiary',
                    query: {
                      date: inputDate.format('YYYY-MM-DD')
                    }
                  })
                })
            }
          });
      },
      toggleNutritionPane() {
        let self = this;
        self.isNutritionPaneVisible = !self.isNutritionPaneVisible;
        if (self.isNutritionPaneVisible !== true) {
          self.leftPaneWidth.tablet = "100";
          self.leftPaneWidth.desktop = "100";
          self.servingPickerWidth.servingInput.desktop = "20";
          self.servingPickerWidth.servingInput.tablet = "20";
          self.servingPickerWidth.servingSelector.desktop = "80";
          self.servingPickerWidth.servingSelector.tablet = "80";
        }
        else {
          self.leftPaneWidth.tablet = "50";
          self.leftPaneWidth.desktop = "50";
          self.servingPickerWidth.servingInput.desktop = "40";
          self.servingPickerWidth.servingInput.tablet = "40";
          self.servingPickerWidth.servingSelector.desktop = "60";
          self.servingPickerWidth.servingSelector.tablet = "60";
        }
      },
      rounded(num) {
        let number = numeral(num.toFixed(2));
        return number.format('0,0.0')
      },
      humanize(str) {
        let frags = str.split('_');
        for (let i = 0; i < frags.length; i++) {
          frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
        }
        return frags.join(' ');
      },
      getUnit(key) {
        switch (key) {
          case 'calories':
            return 'kcal';
            break;
          case 'protein':
            return 'g';
            break;
          case 'carbohydrate':
            return 'g';
            break;
          case 'sugar':
            return 'g';
            break;
          case 'fat':
            return 'g';
            break;
          case 'saturated_fat':
            return 'g';
            break;
          case 'monounsaturated_fat':
            return 'g';
            break;
          case 'polyunsaturated_fat':
            return 'g';
            break;
          case 'cholesterol':
            return 'g';
            break;
          case 'fibre':
            return 'g';
            break;
          case 'sodium':
            return 'mg';
            break;
          case 'potassium':
            return 'mg';
            break;
        }
      },
      goBack() {
        let self = this;
        self.$router.go(-1);
      },
      closeDialog() {
        let self = this;
        self.$router.push({
          name: 'FoodDiary'
        })
      }
    }
  }
</script>
<style scoped>
  .mu-item.show-left {
    padding-left: 56px !important;
  }
</style>
<style>
  #food-diary-add {
    padding: 8px !important;
  }

  #food-diary-add .mu-item.show-left {
    padding-left: 56px !important;
  }

  .nativeInput {
    border: 0;
    font-weight: 400;
    font-size: 16px;
    border-bottom: 1px solid #bcbdc0;
  }
</style>



// WEBPACK FOOTER //
// Add.vue?47a855e2